import React from "react";

const Topbar = () => {
  return (
    <>
      {/* header Top Start */}
      <div className="hd-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-8">
              <div className="hd-lft">
                <ul>
                  <li style={{ display: "none" }}>
                    <i className="fa fa-clock-o" /> 24/7 Security Support
                  </li>
                  <li style={{ display: "none" }}>
                    <i className="fa fa-phone" /> +90 XXX XXX XX XX
                  </li>
                  <li>
                    <i className="fa fa-envelope" /> info@ironwallx.com
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 col-sm-4" style={{ display: "none" }}>
              <div className="hd-rgt">
                <span className="follow-title">Follow Us</span>
                <ul>
                  <li>
                    <a href="https://www.facebook.com/ironwallxsecurity">
                      <i className="fa fa-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/ironwallxsecurity">
                      <i className="fa fa-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/ironwallxsecurity">
                      <i className="fa fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/ironwallxsecurity">
                      <i className="fa fa-linkedin" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/@ironwallxsecurity">
                      <i className="fa fa-youtube-play" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* header Top End */}
    </>
  );
};

export default Topbar;
